var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z6c4dnlima"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 88",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 89",
    style: {
      fill: "#fff"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3",
    style: {
      clipPath: "url(#z6c4dnlima)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 323"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 4",
    transform: "rotate(45 -2.172 5.242)",
    style: {
      fill: "none",
      stroke: "#777",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 5",
    transform: "rotate(135 7.97 5.1)",
    style: {
      fill: "none",
      stroke: "#777",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.39deefbb1a4d945c82780aca169172bd.svg";
export { ForwardRef as ReactComponent };